import React, { useEffect, useState } from "react";
import MyPagination from "../../../components/Common/MyPagination";
import * as contactApi from "../../../apis/contactApi";
import { Table, Card, CardBody, CardTitle, Row, Col, Button, Input, InputGroup } from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import { PropTypes } from "prop-types";
import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import ConfirmDelete from "components/Common/ConfirmDelete";
import ConfirmRestore from "components/Common/ConfirmRestore";
import "flatpickr/dist/themes/material_blue.css"
import FeedbackTableItem from "components/TableItem/FeedbackTableItem";
import MetaTags from 'react-meta-tags';


function ListFeedback(props) {
  const [deleteId, setDeleteId] = useState(null);
  const [restoreId, setRestoreId] = useState(null);
  const selectedShop = useSelector(state => state.SelectedShop);
  const [dataRequest, setDataRequest] = useState({})
  let history = useHistory();
  const showProductCatItem = () => {
    if (dataRequest) {
      if (dataRequest?.total === 0) {
        return <tr></tr>;
      } else {
        return dataRequest?.data && dataRequest?.data.map((v, i) => {
          return (
            <FeedbackTableItem
              key={i}
              data={v}
              count={i + 1}
              deleteCallback={setDeleteId}
              restoreCallback={setRestoreId}
            />
          );
        });
      }
    }
  };

  const onChangePage = page => {
    let url = props.location.pathname + "?page=" + page;
    history.push(url);
  };
  useEffect(() => {
    fetchData();
  }, [])
  const fetchData = page => {
    contactApi.getListFeedback(fetchDataSuccess, fetchDataFail);
  };
  const fetchDataSuccess = res => {
    const { data } = res.data;
    setDataRequest(data)
  };
  const fetchDataFail = res => {
    alert("Không có dữ liệu");
  };

  return (
    <div className="page-content">
      <MetaTags>
          <title>CMS | Phản hồi</title>
      </MetaTags>
      {deleteId ? (
        <ConfirmDelete
          confirmCallback={() => {
            onDelete(deleteId);
          }}
          cancelCallback={() => {
            setDeleteId(null);
          }}
        />
      ) : (
        ""
      )}
      {restoreId ? (
        <ConfirmRestore
          confirmCallback={() => {
            onRestore(restoreId);
          }}
          cancelCallback={() => {
            setRestoreId(null);
          }}
        />
      ) : (
        ""
      )}
      <Card>
        <CardBody>
          <Card color='light'>
            <CardBody>
              <Row className="justify-content-between">
                <Col xs="auto" sm="auto"><CardTitle className="h4">Danh sách phản hồi</CardTitle></Col>
                {/* <Col xs="auto" sm="auto">
                  <Link to="/banner/create">
                    {" "}
                    <Button color="primary" className="px-3 rounded-pill">
                      <i className="fas fa-plus mr-2"></i> Thêm mới
                    </Button>
                  </Link>
                </Col> */}
              </Row>
            </CardBody>
          </Card>
          <div className="table-responsive">
            <Table className="table mb-3 mytable">
              <thead>
                <tr>
                  <th>STT</th>
                  <th>Tên khách</th>
                  <th>Liên hệ</th>
                  <th>Phản hồi</th>
                  <th>Thời gian</th>
                  <th>Thao tác</th>
                </tr>
              </thead>
              <tbody>{showProductCatItem()}</tbody>
            </Table>
          </div>
          <MyPagination
            startPage={dataRequest.current_page ? dataRequest.current_page : 1}
            totalItemsCount={dataRequest.total ? dataRequest.total : 5}
            itemsCountPerPage={dataRequest.per_page ? dataRequest.per_page : 10}
            callback={onChangePage}
          />
        </CardBody>
      </Card>
    </div>
  );
}
ListFeedback.propTypes = {
  location: PropTypes.object,
};

export default withRouter(ListFeedback);
